import {setLoading} from './generalActions';
import {AppDispatch} from '../../store';
import resourcesServices from '../../../api/resourcesServices';
import {ERROR_MODAL, SUCCESS_MODAL} from '../../../components/subComponents/responseModals';
import {resourcesTypes} from '../types';
import { ResourceType } from '../../../types/resourcesTypes';

export const getResources = () => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  resourcesServices.getResources()
  .then((response) => {
    dispatch({
      type: resourcesTypes.GET_RESOURCES,
      resources: response.data
    });
  })
  .catch(err => {
    ERROR_MODAL(err.data.message);
    dispatch(setLoading(false));
  })
}
export const createOrUpdateResources = (resources: ResourceType) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  resourcesServices.createOrUpdate(resources)
    .then((response) => {
      SUCCESS_MODAL(response.data.status);
      dispatch(getResources());
      dispatch(setLoading(false));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}

